import { IMiniGameProps } from '../../../../../../typings/common';
import { BGSlot, BonusSlotGif } from '../../../../../assets';
import BonusGameCard from './BonusGameCard';

function BGSlotGame({
	isSmall,
	onStartGame,
	onRequireLogin,
	canPlay,
	config,
	miniGameData,
	playerLevel,
}: IMiniGameProps) {
	return (
		<BonusGameCard
			isSmall={isSmall}
			onStartGame={onStartGame}
			onRequireLogin={onRequireLogin}
			canPlay={canPlay}
			config={config}
			miniGameData={miniGameData}
			playerLevel={playerLevel}
			titleSource={BGSlot}
			thumbSource={BonusSlotGif}
			launchPath='/slot/bowaPlayer.html'
			cooldownHours={12}
			freePlayTitleFontSize={13}
			infoPaddingVertical={4}
		/>
	);
}

export default BGSlotGame;
